import { getGenSettings } from '@/api/methods/settings';

export default {
  namespaced: true,
  state: {
    getSettings: [],
    idleSettings: {},
    logSettings: {},
    commonSettings: {},
    watermarksSettings: {},
    criticalEventsSettings: null,
    screenshotSettings: {},
    shadowSettings: {},
    fileSettings: {},
    indexSettings: {},
    driveSettings: {},
    inetSettings: {},
    webcamSettings: {},
    notificationSettings: {},
    neiroSettings: {},
    delCompoundRulesSettings: [],
    addCompoundRulesSettings: [],
    editCompoundRulesSettings: [],
    profile: undefined,
    prodProfile: undefined,
    wtProfile: undefined,
    security: { checked: [], unchecked: [] },
    acsel: { checked: [], unchecked: [] },
  },
  getters: {
    getSettings: (state) => state.getSettings,
    localIIUse: (state) => {
      const localIIUseSetting = state.getSettings?.find(({ id }) => +id === 72);
      return +localIIUseSetting?.value === 1;
    },
    idleSettings: (state) => state.idleSettings,
    logSettings: (state) => state.logSettings,
    commonSettings: (state) => state.commonSettings,
    watermarksSettings: (state) => state.watermarksSettings,
    criticalEventsSettings: (state) => state.criticalEventsSettings,
    screenshotSettings: (state) => state.screenshotSettings,
    shadowSettings: (state) => state.shadowSettings,
    fileSettings: (state) => state.fileSettings,
    indexSettings: (state) => state.indexSettings,
    driveSettings: (state) => state.driveSettings,
    inetSettings: (state) => state.inetSettings,
    webcamSettings: (state) => state.webcamSettings,
    notificationSettings: (state) => state.notificationSettings,
    neiroSettings: (state) => state.neiroSettings,
    delCompoundRulesSettings: (state) => state.delCompoundRulesSettings,
    addCompoundRulesSettings: (state) => state.addCompoundRulesSettings,
    editCompoundRulesSettings: (state) => state.editCompoundRulesSettings,
    prodProfile: (state) => state.prodProfile,
    wtProfile: (state) => state.wtProfile,
    security: (state) => state.security,
    acsel: (state) => state.acsel,
    notEmpty: (state) => {
      const hasSettings = [
        state.idleSettings,
        state.logSettings,
        state.commonSettings,
        state.watermarksSettings,

        state.screenshotSettings,
        state.shadowSettings,
        state.fileSettings,
        state.indexSettings,
        state.driveSettings,
        state.inetSettings,
        state.webcamSettings,
        state.notificationSettings,
        state.neiroSettings,
      ].some((obj) => Object.keys(obj).length);

      const hasCriticalEventsSettings = state.criticalEventsSettings;

      const hasCompoundRulesSettings =
        state.delCompoundRulesSettings.length ||
        state.addCompoundRulesSettings.length ||
        state.editCompoundRulesSettings.length;

      const hasArrays =
        state.security.checked.length ||
        state.security.unchecked.length ||
        state.acsel.checked.length ||
        state.acsel.unchecked.length;

      const hasProfiles = state.prodProfile || state.wtProfile;

      return Boolean(hasSettings || hasArrays || hasProfiles || hasCriticalEventsSettings || hasCompoundRulesSettings);
    },
    profile: (state) => state.profile,
  },
  actions: {
    // eslint-disable-next-line
    refresh({ commit, dispatch }) {},
    // eslint-disable-next-line
    cancel({ commit, dispatch }) {},
    // eslint-disable-next-line
    paramChanged({ commit, dispatch }) {},
    getSettings: async (store) => {
      const data = await getGenSettings();
      store.commit('settings/addGenSettings', data, { root: true });
    },
  },
  mutations: {
    addGenSettings: (state, payload) => {
      state.getSettings = payload;
    },
    addIdleSettings: (state, payload) => {
      const newSettings = { ...state.idleSettings };
      newSettings[payload.key] = payload.value;
      state.idleSettings = newSettings;
    },
    addLogSettings: (state, payload) => {
      const newSettings = { ...state.logSettings };
      newSettings[payload.key] = payload.value;
      state.logSettings = newSettings;
    },
    addCommonSettings: (state, payload) => {
      const newSettings = { ...state.commonSettings };
      newSettings[payload.key] = payload.value;
      state.commonSettings = newSettings;
    },
    addWatermarksSettings: (state, payload) => {
      const newSettings = { ...state.watermarksSettings };
      newSettings[payload.key] = payload.value;
      state.watermarksSettings = newSettings;
    },
    addCriticalEventsSettings: (state, payload) => {
      state.criticalEventsSettings = payload;
    },
    addScreenshotSettings: (state, payload) => {
      const newSettings = { ...state.screenshotSettings };
      newSettings[payload.key] = payload.value;
      state.screenshotSettings = newSettings;
    },
    addShadowSettings: (state, payload) => {
      const newSettings = { ...state.shadowSettings };
      newSettings[payload.key] = payload.value;
      state.shadowSettings = newSettings;
    },
    addFileSettings: (state, payload) => {
      const newSettings = { ...state.fileSettings };
      newSettings[payload.key] = payload.value;
      state.fileSettings = newSettings;
    },
    addIndexSettings: (state, payload) => {
      const newSettings = { ...state.indexSettings };
      newSettings[payload.key] = payload.value;
      state.indexSettings = newSettings;
    },
    addDriveSettings: (state, payload) => {
      const newSettings = { ...state.driveSettings };
      newSettings[payload.key] = payload.value;
      state.driveSettings = newSettings;
    },
    addInetSettings: (state, payload) => {
      const newSettings = { ...state.inetSettings };
      newSettings[payload.key] = payload.value;
      state.inetSettings = newSettings;
    },
    addWebcamSettings: (state, payload) => {
      const newSettings = { ...state.webcamSettings };
      newSettings[payload.key] = payload.value;
      state.webcamSettings = newSettings;
    },
    addNotificationSettings: (state, payload) => {
      const newSettings = { ...state.notificationSettings };
      newSettings[payload.key] = payload.value;
      state.notificationSettings = newSettings;
    },
    addNeiroSettings: (state, payload) => {
      state.neiroSettings = payload;
    },
    delCompoundRulesSettings: (state, payload) => {
      state.delCompoundRulesSettings.push(payload);
    },
    addCompoundRulesSettings: (state, payload) => {
      state.addCompoundRulesSettings.push(payload);
    },
    editCompoundRulesSettings: (state, payload) => {
      state.editCompoundRulesSettings.push(payload);
    },
    updateCompoundRulesSettings: (state, payload) => {
      const index = state.addCompoundRulesSettings.findIndex((item) => item.id === payload.id);

      if (index !== -1) {
        state.addCompoundRulesSettings.splice(index, 1, payload);
      }
    },
    removeAddCompoundRulesSettings: (state, id) => {
      state.addCompoundRulesSettings = state.addCompoundRulesSettings.filter((item) => item.id !== id);
    },

    addVideoSettings: (state, payload) => {
      const newSettings = { ...state.webcamSettings.Video };
      newSettings[payload.key] = payload.value;
      const result = { ...state.webcamSettings };
      result.Video = newSettings;
      state.webcamSettings = result;
    },
    addAudioSettings: (state, payload) => {
      const newSettings = { ...state.webcamSettings.Audio };
      newSettings[payload.key] = payload.value;
      const result = { ...state.webcamSettings };
      result.Audio = newSettings;
      state.webcamSettings = result;
    },
    addScreenSettings: (state, payload) => {
      const newSettings = { ...state.webcamSettings.Screen };
      newSettings[payload.key] = payload.value;
      const result = { ...state.webcamSettings };
      result.Screen = newSettings;
      state.webcamSettings = result;
    },
    addSecurity: (state, payload) => {
      const newSettings = { ...state.security };
      if (payload.checked) {
        const indexOfObject = newSettings.unchecked.findIndex((object) => object.ruleId === payload.ruleId);
        if (indexOfObject > -1) newSettings.unchecked.splice(indexOfObject, 1);
        else newSettings.checked.push(payload);
      } else {
        const indexOfObject = newSettings.checked.findIndex((object) => object.ruleId === payload.ruleId);
        if (indexOfObject > -1) newSettings.checked.splice(indexOfObject, 1);
        else newSettings.unchecked.push(payload);
      }
      state.security = newSettings;
    },
    addAcsel: (state, payload) => {
      const newSettings = { ...state.acsel };
      if (payload.checked) {
        const indexOfObject = newSettings.unchecked.findIndex((object) => object.stype === payload.stype);
        if (indexOfObject > -1) newSettings.unchecked.splice(indexOfObject, 1);
        else {
          const indexOfObject2 = newSettings.checked.findIndex((object) => object.stype === payload.stype);
          if (indexOfObject2 > -1) newSettings.checked.splice(indexOfObject2, 1);
        }
        newSettings.checked.push(payload);
      } else {
        const indexOfObject = newSettings.checked.findIndex((object) => object.stype === payload.stype);
        if (indexOfObject > -1) newSettings.checked.splice(indexOfObject, 1);
        newSettings.unchecked.push(payload);
      }
      state.acsel = newSettings;
    },
    clearChangedSettings: (state) => {
      state.idleSettings = {};
      state.logSettings = {};
      state.commonSettings = {};
      state.watermarksSettings = {};
      state.criticalEventsSettings = null;
      state.screenshotSettings = {};
      state.shadowSettings = {};
      state.fileSettings = {};
      state.indexSettings = {};
      state.driveSettings = {};
      state.inetSettings = {};
      state.webcamSettings = {};
      state.notificationSettings = {};
      state.neiroSettings = {};
      state.delCompoundRulesSettings = [];
      state.addCompoundRulesSettings = [];
      state.editCompoundRulesSettings = [];
      state.prodProfile = undefined;
      state.wtProfile = undefined;
      state.security = { checked: [], unchecked: [] };
      state.acsel = { checked: [], unchecked: [] };
    },
    setProfile: (state, payload) => {
      state.profile = payload;
    },
    setProdProfile: (state, payload) => {
      state.prodProfile = payload;
    },
    setWtProfile: (state, payload) => {
      state.wtProfile = payload;
    },
  },
};
